import type { SearchTileDensity } from './searchTileDensity'

export const SEARCH_TILE_BREAKPOINTS = {
  tablet: 578,
  desktopSmall: 670,
  desktop: 890,
} as const

// Match the standard tile's alternating column/row layouts, not viewport width.
export function hasSearchTilePricingColumn(width: number, density: SearchTileDensity): boolean {
  return density === 'default' && (
    (width >= SEARCH_TILE_BREAKPOINTS.tablet && width < SEARCH_TILE_BREAKPOINTS.desktopSmall) ||
    width >= SEARCH_TILE_BREAKPOINTS.desktop
  )
}
